// removed by extract-text-webpack-plugin
module.exports = {"profile":"JmD9RgpseyQdqQb9x-LXt","pagination":"_32e7GdO9vW8jt7zH3rcUup","text-center":"osPd-c9iXAHIz-Zin19zH"};


//////////////////
// WEBPACK FOOTER
// ./components/profile/style.less
// module id = 1155
// module chunks = 0